<template>
  <div
    class="reporting-metric-toggle"
    :class="{'reporting-metric-toggle--selected': selected}"
    :style="`border-color: ${selected ? parameter.color : ''}`"
  >
    <div
      class="title m-b-0"
    >
      {{ parameter.title }}
    </div>

    <!-- <div>
      <strong>
        Total: {{ formattedTotalValue }}
      </strong>
    </div> -->
  </div>
</template>

<script>
import formatNumber from '@/core/filters/formatNumber';
import formatCurrency from '@/core/filters/formatCurrency';

export default {
  name: 'ReportingMetricToggle',
  props: {
    parameter: {
      type: Object,
      default() {
        return {};
      }
    },
    selected: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    formattedTotalValue() {
      return this.parameter.dataType === 'currency' ? formatCurrency(this.parameter.totalValue) : formatNumber(this.parameter.totalValue);
    }
  },
};
</script>

<style lang="scss" scoped>
.reporting-metric-toggle {
  border: 1px solid var(--component-callout-border-color);
  padding: 10px;
  cursor: pointer;
}
</style>